import { Button, Card as FPDSCard } from '@fcamna/react-library';
import { htmlReactParser } from '../utils/htmlReactParser';
import { TCardAemProp } from '../model/AemDataProps';
import { AnalyticsEvent } from '../analytics/defaultDigitalData';
import { Icon } from '@fcamna/react-library';
import './Card.scss';

export enum RatioPropEnum {
  OneToOne = '1/1',
  SixteenToNine = '16/9',
}

export enum CardTypeEnum {
  Ghost = 'ghost',
  Default = 'default',
}

export enum CardOrientationEnum {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export enum CardTitleHeadingLevelEnum {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
}

export enum CardTitleSizeEnum {
  LARGE = 'large',
  EXTRALARGE = 'extraLarge',
}

export interface ICustomCardProp {
  cardAemProp: TCardAemProp;
  cardType?: CardTypeEnum;
  ratioProp?: RatioPropEnum;
  titleHeadingLevel?: CardTitleHeadingLevelEnum;
  titleSize?: CardTitleSizeEnum;
  analyticsValue?: AnalyticsEvent | null;
  orientationProp: CardOrientationEnum;
  buttonType?: string;
  className?: string;
}

export function Card({
  cardAemProp,
  cardType = CardTypeEnum.Default,
  ratioProp = RatioPropEnum.SixteenToNine,
  titleHeadingLevel = CardTitleHeadingLevelEnum.H1,
  titleSize = CardTitleSizeEnum.EXTRALARGE,
  orientationProp = CardOrientationEnum.Vertical,
  buttonType,
  className,
}: ICustomCardProp) {
  const assetBaseURL = window?.ENV_CONFIG?.AEM_API_HOST;

  return (
    <FPDSCard
      titleProp={{
        // title: rawHtmlParser(cardAemProp.heading)?.innerText as string,
        title: htmlReactParser(cardAemProp?.heading ?? ''),
        headingLevel: titleHeadingLevel,
        size: titleSize,
      }}
      ratio={ratioProp}
      cardType={cardType}
      orientation={orientationProp}
      // orientation={
      //   cardAemProp.type && cardAemProp.type === 'horizontal-feature-section'
      //     ? CardOrientationEnum.Horizontal
      //     : CardOrientationEnum.Vertical
      // }
      right={!!(cardAemProp.imageAlign && cardAemProp.imageAlign === 'Right')}
      className={className}
    >
      <FPDSCard.Media>
        <img src={assetBaseURL + cardAemProp.image} alt={cardAemProp.imageAltText} />
      </FPDSCard.Media>

      <FPDSCard.Body>{htmlReactParser(cardAemProp.text)}</FPDSCard.Body>

      <FPDSCard.Footer>
        {cardAemProp.ctaText && (
          <Button
            onClick={() => {
              window.open(
                cardAemProp.ctaUrl?.startsWith('https')
                  ? cardAemProp.ctaUrl
                  : window.location.origin + cardAemProp.ctaUrl,
                cardAemProp.ctaTarget === 'sameWindow' ? '_self' : '_blank',
              );
            }}
            aria-label={cardAemProp.ctaAriaLabel}
            variant={buttonType}
            {...(cardAemProp.ctaTarget !== 'sameWindow' && { rightIcon: <Icon icon={'popUp'} /> })}
          >
            {cardAemProp.ctaText}
          </Button>
        )}
      </FPDSCard.Footer>
    </FPDSCard>
  );
}
